import { NariShaktiLogo } from "@/assets";

const Logo = () => (
  <div className="flex justify-center w-full mb-6">
    <img
      src={NariShaktiLogo}
      alt="Nari Suraksha Logo"
      className="w-20 h-20 rounded-full bg-white p-2 border-2 border-primary/20 shadow-lg"
    />
  </div>
);

export default Logo;
